module.exports = __webpack_public_path__ + "static/media/webdesign-services-img33.cbaf3aad.jpg";